<script>
  import {mapState, mapActions, mapGetters} from 'vuex'


  export default {
    props: {
      label: String,
      name: {
        type: [String, Array, Number]
      },
      value: {
        type: [String, Array, Number]
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      cType: {
        type: Number,
      },
      add: {
        type: Boolean,
        default: false,
      },
      isCustomer: {
        type: Boolean,
        default: false,
      },
      hideClient: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        val: this.value,
        lab: this.name,
        modal: false
      }
    },
    methods: {
      change(v) {
        this.val = v.value;
        this.lab = v.label;
        this.$emit('input', v.value);
        this.$emit('update:label', v.label);
        this.$emit('change', v);

      },
      changePartnerAdd(v) {
        this.$emit('input', v.value);
        this.$emit('update:label', v.label);
        this.$emit('change', v);
      },
      click() {
        switch (this.cType) {
          case 1:
          case 5:
            this.$dialog('client_search', {
              change: this.change,
            });
            break;
          case 2:
            this.$dialog('partner_search', {
              change: this.change,
              typePartners: 2,
            });
            break;
          case 3:
            this.$dialog('partner_search', {
              change: this.change,
              typePartners: 1,
            });
            break;
          case 6:
            this.$dialog('partner_search', {
              change: this.change,
            });
            break;
          default:
            this.$dialog('contragent_search', {
              change: this.change,
              hideClient: this.hideClient,
            });

        }
      },
      click_add() {

        switch (this.cType) {
          case 1:
          case 5:
            if (this.permission(41)) this.$dialog('client_add', {
              change: this.change,
            });
            break;
          case 2:
            if (this.permission(12)) this.$dialog('partner_add', {
              IsCustomer: true,
              change: this.change
            });
            break;
          case 3:
            if (this.permission(12)) this.$dialog('partner_add', {
              IsOperator: true,
              change: this.change
            });
            break;
          case 6:
            if (this.permission(12)) this.$dialog('partner_add', {
              IsCustomer: false,
              change: this.change
            });
            break;
          default:
            if (this.permission(12) && this.permission(41)) {
              let data = {
                change: this.change,
                hideClient: this.hideClient,
              };
              if (this.isCustomer) data.IsCustomer = true;
              this.$dialog('contragent_add', data);
            } else if (this.permission(12)) {
              this.$dialog('partner_add', {
                change: this.change
              });
            } else if (this.permission(41)) {
              this.$dialog('client_add', {
                change: this.change,
              });
            }
        }
      },
      remove() {
        this.val = null;
        this.lab = '';
        this.$emit('input', this.val);
        this.$emit('update:label', this.lab);
        this.$emit('change', {
          value: this.val,
          label: this.lab,
        });
      },
    },
    computed: {
      ...mapGetters({
        permission: 'permission',
      }),
    },
    watch: {
      value(v) {
        this.val = v;
      },
      name(v) {
        this.lab = v;
      },
    },
    components: {},
    mounted() {
      window.vm = this;
    },
    destroyed() {
    },
  }
</script>
<template>
  <div class="input-contragent">
    <el-input :value="lab" disabled>
      <template v-if="label" slot="prepend">{{label}}</template>
      <el-button
        v-if="val"
        slot="append"
        icon="el-icon-close"
        title="Удалить"
        @click="remove"
        :disabled="disabled">
      </el-button>
      <el-button
        v-if="add&&(permission(12)||this.permission(41))"
        slot="append"
        icon="el-icon-plus"
        title="Добавить"
        @click="click_add"
        :disabled="disabled">
      </el-button>
      <el-button
        slot="append"
        icon="el-icon-search"
        title="Найти"
        @click="click"
        :disabled="disabled">
      </el-button>
    </el-input>
  </div>
</template>
<style lang="scss">
  .input-contragent {
    position: relative;
    .el-input.is-disabled .el-input__inner {
      background: #fff;
      cursor: default;
      color: #333;
    }
  }
</style>
